import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import * as sessionUserSelector from 'selectors/sessionUser'


import colors from 'components/utils/colors'

import LeftSidebar from 'components/Shared/Sidebar/LeftSidebar'
import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import FilterList from 'components/Shared/FilterList/Index'

import { complianceOptions } from 'utils/satCompliance'

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 48px;
  padding: 0 8px;
  background-color: #FFFFFF;
  line-height: 24px;
  border-bottom: 1px solid ${colors.secondary70};
`

const Title = styled.div`
  font-family: Exo;
  font-size: 20px;
  text-transform: uppercase;
  color: ${colors.secondary40};
`

const CloseButton = styled(IconLink)`
  position: absolute;
  right: 10px;
`

/* eslint-disable no-multi-spaces */
const buildFilterSectionsDesc = (t, capabilityList) => {
  const boolOptions = [
    { value: 'true', label: 'True' },
    { value: 'false', label: 'False' },
  ]

  return [
    { name: 'client_id',               title: t('satClientsPage.filters.clientId'),            type: 'text' },
    { name: 'capabilities',            title: t('satClientsPage.filters.capabilities'),        type: 'multiselect', options: capabilityList },
    { name: 'compliance_statuses',     title: t('satClientsPage.filters.compliance'),          type: 'multiselect', options: complianceOptions(t) },
    { name: 'enabled',                 title: t('satClientsPage.filters.enabled'),             type: 'select',      options: boolOptions },
    { name: 'approved',                title: t('satClientsPage.filters.approved'),            type: 'select',      options: boolOptions },
    { name: 'expires_at_start_date',   title: t('satClientsPage.filters.expiresAtStartDate'),  type: 'date' },
    { name: 'expires_at_end_date',     title: t('satClientsPage.filters.expiresAtEndDate'),    type: 'date' },
    { name: 'last_used_at_start_date', title: t('satClientsPage.filters.lastUsedAtStartDate'), type: 'date' },
    { name: 'last_used_at_end_date',   title: t('satClientsPage.filters.lastUsedAtEndDate'),   type: 'date' },
  ]
}
/* eslint-enable no-multi-spaces */

const FiltersSidebar = ({ activeFilters, isVisible, onClose, capabilityList, onFilterChange }) => {
  const { t } = useTranslation()
  const userTimeZone = useSelector(sessionUserSelector.timezone)
  const filterSectionsDesc = buildFilterSectionsDesc(t, capabilityList)

  const Header = () => {
    return (
      <StyledHeader data-test='filters-header'>
        <Title>{t('satClientsPage.filterPanelTitle')}</Title>

        <Tooltip place='left' id='filter-tooltip' />

        <CloseButton
          onClick={onClose}
          iconName='icon-delete-16'
          data-tooltip-content={t('common.close')}
          data-tooltip-id='filter-tooltip'
        />
      </StyledHeader>
    )
  }

  return (
    <LeftSidebar
      show={isVisible}
      dataTest='sat-clients-filters'
      headerComponent={<Header />}
    >
      <FilterList
        activeFilters={activeFilters}
        onFilterChange={onFilterChange}
        filterSectionsDesc={filterSectionsDesc}
        userTimeZone={userTimeZone}
      />
    </LeftSidebar>
  )
}

FiltersSidebar.propTypes = {
  activeFilters: PropTypes.object.isRequired,
  isVisible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  capabilityList: PropTypes.array.isRequired,
  onFilterChange: PropTypes.func.isRequired,
}

export default FiltersSidebar
